import { render, staticRenderFns } from "./DatasetCreate.vue?vue&type=template&id=7a8b5cda&"
import script from "./DatasetCreate.vue?vue&type=script&lang=js&"
export * from "./DatasetCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports